import React from "react";
import styles from "./loading.module.scss";

const Loading = ()=>(
    <div className={styles.loading}>

    </div>
)

export default Loading;